<template lang="">
    <div class='flex items-center justify-center h-screen w-screen'> 
        <MessageEvent v-if='messagesStore.active === true'/>
    <div  >
        <FormKit type='form' :actions="false" id='loginForm' @submit="loginMethod" >
            <div class='flex flex-col gap-2'>
                
            <div class='text-4xl'>Login!</div>
            <div class='max-w-md'>This is your weight noting service. Help motivate yourself by seeing your progress in really ATTRACTIVE numbers and charts!</div>
            </div>
            
            <hr />
            <div class='flex flex-row justify-around items-center'>
                <div  class='flex flex-col justify-center gap-2'>
   

                        <FormKit type="text" name="email" label="Email" placeholder="henry@gmail.com" validation="required"></FormKit>
                        <FormKit type='password' name='password' label='Password' validation="required|matches:/[^a-zA-Z]/" placeholder='Your password'> </FormKit>
                        <div class=' flex justify-end'>  <FormKit type="submit" label="Login" class="login-button" />         </div>
               
                        <div class='p-2'></div>
                    Dont have account?
                 
                    <a href='register' class='text-blue-600'> Register!</a>
                  



                </div>
     
                <img src="../../public/icon-images/undraw_fitness_stats_sht6.svg" class='w-1/2'/>
                
            </div>
            

         
        </FormKit>
      
    </div>
 
</div>
    
</template>
<script setup>
import MessageEvent from './MessageEvent.vue';
// eslint-disable-next-line no-unused-vars
import UserService, { checkTokenIfActive, getUserInfo } from '@/services/UserService';
import { onMounted} from 'vue';
import { useRouter } from 'vue-router';
import { MessageStore } from '@/stores/Messages';


// eslint-disable-next-line no-unused-vars
const messagesStore = MessageStore();

// eslint-disable-next-line no-unused-vars
const router = useRouter()


async function checkIfLogged(){
    const response = await checkTokenIfActive();
    
    if(response === true){
        router.push('/dashboard')

    }

  

  
}


onMounted(async () => {


    try {
        checkIfLogged()

    } catch (error) {
        console.log(error)
    }




});




async function loginMethod(values) {

    // eslint-disable-next-line no-unused-vars
    let prepareDoc = {
        Email: values.email,
        password: values.password
    }

    try {
    let response = await UserService.loginUser(prepareDoc);

    if (response === true) {

      location.reload();

    }
    else{
      
        if(response.boolean === false){
            
            messagesStore.setMessage(response.message, false);

        }
    }
  } catch (error) {
  
    console.error(error);
  }
}



</script>

<style lang="css">


</style>